"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _locale = require("../locale");
var _components = _interopRequireDefault(require("../previews/components"));
var _makeStyle = _interopRequireDefault(require("../utils/makeStyle"));
var _ComponentCard = _interopRequireWildcard(require("./ComponentCard"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyle = (0, _makeStyle.default)('ComponentDemoGroup', function (token) {
  return {
    '.previewer-component-demo-group': {
      display: 'flex',
      width: '100%',
      overflow: 'hidden',
      '&:first-child': {
        '.previewer-component-demo-group-item': {
          paddingTop: token.padding
        }
      },
      '&:last-child': {
        '.previewer-component-demo-group-item': {
          paddingBottom: token.padding
        }
      }
    }
  };
});
var useDemoStyle = (0, _makeStyle.default)('ComponentDemoBlock', function (token) {
  return {
    '.previewer-component-demo-group-item': {
      flex: '1 1 50%',
      paddingInline: token.padding,
      paddingBlock: token.padding / 2,
      width: 0,
      backgroundColor: token.colorBgLayout,
      '.previewer-component-demo-group-item-relative-token': {
        color: token.colorTextSecondary,
        paddingBottom: 8,
        '&:not(:first-child)': {
          marginTop: 12
        }
      }
    }
  };
});
var ComponentDemoBlock = function ComponentDemoBlock(_ref) {
  var _demos$;
  var component = _ref.component,
    onTokenClick = _ref.onTokenClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'middle' : _ref$size,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$demos = _ref.demos,
    demos = _ref$demos === void 0 ? [] : _ref$demos,
    theme = _ref.theme,
    componentDrawer = _ref.componentDrawer;
  var _useDemoStyle = useDemoStyle(),
    _useDemoStyle2 = (0, _slicedToArray2.default)(_useDemoStyle, 2),
    hashId = _useDemoStyle2[1];
  var locale = (0, _locale.useLocale)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('previewer-component-demo-group-item', hashId)
  }, /*#__PURE__*/_react.default.createElement(_ComponentCard.default, {
    title: component,
    component: component,
    onTokenClick: onTokenClick,
    drawer: componentDrawer,
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_antd.ConfigProvider, {
    componentSize: size,
    componentDisabled: disabled
  }, demos.some(function (item) {
    return item.active;
  }) ? demos.map(function (demo) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: demo.key,
      style: {
        display: demo.active ? '' : 'none'
      }
    }, demo.tokens && /*#__PURE__*/_react.default.createElement("div", {
      className: "previewer-component-demo-group-item-relative-token"
    }, /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
      title: demo.tokens.join(', ')
    }, /*#__PURE__*/_react.default.createElement("span", null, locale.demo.relatedTokens, ":", ' ', demo.tokens.slice(0, 2).join(', '), demo.tokens.length > 2 ? '...' : ''))), demo.demo);
  }) : (_demos$ = demos[0]) === null || _demos$ === void 0 ? void 0 : _demos$.demo)));
};
var ComponentDemoGroup = function ComponentDemoGroup(_ref2) {
  var themes = _ref2.themes,
    components = _ref2.components,
    size = _ref2.size,
    disabled = _ref2.disabled,
    activeComponents = _ref2.activeComponents,
    selectedTokens = _ref2.selectedTokens,
    onTokenClick = _ref2.onTokenClick,
    componentDrawer = _ref2.componentDrawer,
    hideTokens = _ref2.hideTokens;
  var _useStyle = useStyle(),
    _useStyle2 = (0, _slicedToArray2.default)(_useStyle, 2),
    wrapSSR = _useStyle2[0],
    hashId = _useStyle2[1];
  return wrapSSR( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, Object.entries(components).reduce(function (result, _ref3) {
    var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
      group = _ref4[1];
    return result.concat(group);
  }, []).map(function (item) {
    var componentDemos = _components.default[item];
    if (!componentDemos) {
      return null;
    }
    var demos = componentDemos.map(function (demo, index) {
      return _objectSpread(_objectSpread({}, demo), {}, {
        tokens: hideTokens ? undefined : demo.tokens,
        active: (!selectedTokens || selectedTokens.length === 0) && index === 0 || (selectedTokens === null || selectedTokens === void 0 ? void 0 : selectedTokens.some(function (token) {
          var _demo$tokens;
          return (_demo$tokens = demo.tokens) === null || _demo$tokens === void 0 ? void 0 : _demo$tokens.includes(token);
        }))
      });
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('previewer-component-demo-group', hashId),
      key: item,
      id: (0, _ComponentCard.getComponentDemoId)(item),
      style: {
        display: !activeComponents || activeComponents.length === 0 || activeComponents.includes(item) ? '' : 'none'
      }
    }, themes.length > 1 ? themes.map(function (theme) {
      return /*#__PURE__*/_react.default.createElement(_antd.ConfigProvider, {
        key: theme.key,
        theme: theme.config
      }, /*#__PURE__*/_react.default.createElement(ComponentDemoBlock, {
        component: item,
        onTokenClick: onTokenClick,
        demos: demos,
        disabled: disabled,
        size: size,
        theme: theme,
        componentDrawer: componentDrawer
      }));
    }) : /*#__PURE__*/_react.default.createElement(ComponentDemoBlock, {
      component: item,
      onTokenClick: onTokenClick,
      demos: demos,
      disabled: disabled,
      size: size,
      theme: themes[0],
      componentDrawer: componentDrawer
    }));
  })));
};
var _default = exports.default = ComponentDemoGroup;